/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function bgn_openTab(a, b) {
    var c, d, e;
    for (d = document.getElementsByClassName("bgn_product_tabcontent"),
    c = 0; c < d.length; c++)
        d[c].style.display = "none";
    for (e = document.getElementsByClassName("bgn_product_tablinks"),
    c = 0; c < e.length; c++)
        e[c].className = e[c].className.replace(" bgn_product_active", "");
    document.getElementById(b).style.display = "block",
    a.currentTarget.className += " bgn_product_active"
}
document.addEventListener("DOMContentLoaded", function() {
    var a = document.querySelector(".product-gallery__image");
    a && document.addEventListener("click", function(a) {
        var b = a.target;
        if ((b.classList.contains("product-gallery__image") || b.closest(".product-gallery__carousel-item")) && !b.classList.contains("product-gallery__carousel-item")) {
            b = b.closest(".product-gallery__carousel-item");
            for (var c, d = +b.getAttribute("data-index") - 1, e = [], f = b.closest(".product-gallery__carousel-wrapper").querySelectorAll(".product-gallery__carousel-item"), g = 0; g < f.length; g++)
                if (c = f[g].querySelector(".product-gallery__image"),
                c) {
                    var h = c.getAttribute("data-zoom")
                      , j = c.getAttribute("data-image-width")
                      , k = c.getAttribute("data-image-height");
                    e.push({
                        src: h,
                        w: j,
                        h: k
                    })
                }
            var l = document.querySelectorAll(".pswp")[0]
              , m = new PhotoSwipe(l,PhotoSwipeUI_Default,e,{
                index: d,
                history: false
            });
            m.init()
        }
    });
    var b = document.querySelector(".pswp__button-icon");
    b && document.addEventListener("click", function(a) {
        var b = a.target;
        (b.classList.contains("pswp__button-icon") || b.closest(".pswp__button--arrow")) && !b.classList.contains("pswp__button--arrow") && b.closest(".pswp__button--arrow").click()
    });
    document.addEventListener("change", function(a) {
        var b = a.target;
        if (b.classList.contains("main_check")) {
            var c = b.closest("table").querySelectorAll(".line-item--check");
            b.checked ? c.forEach(function(a) {
                a.checked = !0
            }) : c.forEach(function(a) {
                a.checked = !1
            })
        }
    }),
    document.addEventListener("click", function(a) {
        var b = a.target;
        if (b.classList.contains("removeSelectedItems") || b.closest(".removeSelectedItems")) {
            b.classList.contains("removeSelectedItems") || (b = b.closest(".removeSelectedItems")),
            a.preventDefault();
            var c = b.closest(".cart-wrapper").querySelectorAll(".line-item--check");
            if (c.length) {
                var d = [];
                c.forEach(function(a) {
                    if (!0 == a.checked) {
                        var b = a.getAttribute("data-variant-id");
                        d.push(b)
                    }
                });
                var e = function() {
                    if (d.length) {
                        var a = d.shift();
                        jQuery.ajax({
                            type: "POST",
                            url: "/cart/change.js",
                            dataType: "json",
                            data: "id=" + a + "&quantity=0",
                            success: function() {
                                e()
                            },
                            error: function() {
                                d.length ? e() : location.reload()
                            }
                        })
                    } else
                        location.reload()
                };
                d.length && e()
            }
        }
    })
});

